module.exports = __webpack_public_path__ + "static/img/kj1-4.e5d1a0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-4.png
// module id = 921
// module chunks = 0